import React, { useState, useEffect } from 'react';
import {
  Button,
  Checkbox,
  ExpandableCard,
  Flexbox,
  RadioInput,
  SingleSelect,
  TextInput
} from '@ibinder/common-frontend';
import { FORM_TYPES } from '../../utils/FormTypes';
import styled from 'styled-components';

const InputItem = styled.div`
  margin-bottom: 1rem;
`;

const StyledText = styled.p`
  color: ${({ theme }) => theme.colors.discrete70};
  font-weight: ${(props) => props.theme.fontStyles.extraSmallFont.fontWeight};
  font-size: ${(props) => props.theme.fontStyles.extraSmallFont.fontSize}px;
`;

const IssueTemplateItem = ({
  item,
  formData,
  setFormData,
  setSelectedRoleType,
  roleTypes,
  selectedRoleType,
  index
}) => {
  let activeIndex = Object.keys(FORM_TYPES).findIndex(
    (k) => item.formTypeValue === FORM_TYPES[k]
  );
  const [selectedRoleTypeId, setSelectedRoleTypeId] = useState(
    selectedRoleType?.role?.id
  );

  useEffect(() => {
    if (selectedRoleType.index === item.index)
      setSelectedRoleTypeId(selectedRoleType.role.id);
  }, [selectedRoleType]);

  const changeFieldType = (val) => {
    let type = val[1] === FORM_TYPES.Option ? 'options' : 'text';

    switch (val[1]) {
      case FORM_TYPES.Option:
        return setFormData((prevState) =>
          prevState.map((x) => {
            return x.index === item.index
              ? { ...x, formTypeValue: FORM_TYPES.Option, type }
              : x;
          })
        );
      case FORM_TYPES.TextForm:
        return setFormData((prevState) =>
          prevState.map((x) => {
            return x.index === item.index
              ? { ...x, formTypeValue: FORM_TYPES.TextForm, type }
              : x;
          })
        );
      case FORM_TYPES.PhotoUpload:
        return setFormData((prevState) =>
          prevState.map((x) => {
            return x.index === item.index
              ? {
                  ...x,
                  formTypeValue: FORM_TYPES.PhotoUpload,
                  id: 'GLOBAL_PhotoUrl',
                  type
                }
              : x;
          })
        );
    }
  };
  const changeValue = (val, key) => {
    let newFieldType = formData.map((x) => {
      return x.index === item.index ? { ...x, [key]: val } : x;
    });
    setFormData(newFieldType);
  };

  const toggleBool = (status, key) => {
    let newFieldType = formData.map((x) => {
      return x.index === item.index ? { ...x, [key]: status } : x;
    });
    setFormData(newFieldType);
  };

  const changeRadio = (e) => {
    if (roleTypes)
      roleTypes.map((role) => {
        if (role.id === e) setSelectedRoleType({ index, role });
      });
  };

  const removeField = () => {
    setFormData((prevState) => prevState.filter((x) => x.index !== item.index));
  };

  return (
    <ExpandableCard
      expanded={item.expanded}
      headerInfo={`${item.formLabel}`}
      onHeaderClick={() => !item.expanded && toggleBool(true, 'expanded')}
    >
      <Flexbox flexDirection="column">
        <InputItem>
          <TextInput
            changeValue={(e) => changeValue(e.target.value, 'formLabel')}
            value={item.formLabel}
            placeholder={item.formLabel}
            type="text"
            label="Label"
          />
          <StyledText>
            Label will be shown when the user creates an issue.
          </StyledText>
        </InputItem>
        <InputItem>
          <TextInput
            changeValue={(e) => changeValue(e.target.value, 'id')}
            value={item.id}
            placeholder={item.id}
            type="text"
            label="Metadata Id"
            disabled={item.locked}
          />
        </InputItem>
        <InputItem>
          <TextInput
            changeValue={(e) => changeValue(e.target.value, 'name')}
            value={item.name}
            placeholder={item.name}
            type="text"
            label="Metadata Name"
            disabled={item.locked}
          />
        </InputItem>
        <InputItem>
          <SingleSelect
            activeIndex={activeIndex}
            onClickSelectItem={(e) =>
              changeFieldType(Object.entries(FORM_TYPES)[e])
            }
            dropdownData={Object.keys(FORM_TYPES).map((type) => {
              return {
                Value: FORM_TYPES[type],
                Key: FORM_TYPES[type]
              };
            })}
            label="Choose type of field"
            withSortButton={false}
            disabled={item.locked}
          />
        </InputItem>
        {FORM_TYPES.Option === item.formTypeValue && (
          <RadioInput
            selectedKey={selectedRoleTypeId}
            onClick={(e) => changeRadio(e)}
            id={index}
            data={
              roleTypes &&
              roleTypes.map((role) => ({
                Value: role.name,
                Key: role.id
              }))
            }
          />
        )}
      </Flexbox>
      <InputItem>
        <Checkbox
          onChange={() => toggleBool(!item.required, 'required')}
          className=""
          checked={item.required}
          label="Required"
          disabled={item.locked}
        />
      </InputItem>
      <Flexbox justifyContent="space-between">
        {!item.locked && (
          <Button
            btnType="regular"
            btnStyle="secondary"
            label="Remove"
            onClick={removeField}
          />
        )}
        <Button
          btnType="regular"
          btnStyle="primary"
          label="Save"
          onClick={() => toggleBool(false, 'expanded')}
        />
      </Flexbox>
    </ExpandableCard>
  );
};

export default IssueTemplateItem;
